// extracted by mini-css-extract-plugin
module.exports = {"selectedTrackColor":"#f36a10","unselectedTrackColor":"#707070","divider":"LeaveWarningModal_divider__1tcbz","modalButtonContainer":"LeaveWarningModal_modalButtonContainer__2FHT3"};